export const listWrapper = ({ theme: { colors } }) => ({
    margin: '0 0 48px',
    borderRadius: '6px',
    backgroundColor: colors.white,
});
